// Minimal local types — avoids depending on lib.dom Wake Lock definitions.
interface WLSentinel {
  release(): Promise<void>;
  addEventListener?(type: "release", listener: () => void): void;
}
interface WLNavigator { wakeLock: { request(type: "screen"): Promise<WLSentinel> }; }

let sentinel: WLSentinel | null = null;
let active = false;

export function isSupported(): boolean {
  return typeof navigator !== "undefined" && "wakeLock" in navigator;
}

async function acquire(): Promise<void> {
  if (!active || !isSupported()) return;
  try {
    sentinel = await (navigator as unknown as WLNavigator).wakeLock.request("screen");
    if (!active) { void sentinel.release(); sentinel = null; return; }
    sentinel.addEventListener?.("release", () => { sentinel = null; });
  } catch {
    /* denied or tab not visible; ignore */
  }
}

export async function enable(): Promise<void> {
  active = true;
  await acquire();
}

export function disable(): void {
  active = false;
  void sentinel?.release();
  sentinel = null;
}

// The OS releases the lock when the tab is backgrounded; re-acquire on return.
export function initReacquire(): void {
  document.addEventListener("visibilitychange", () => {
    if (document.visibilityState === "visible" && active && !sentinel) void acquire();
  });
}
